import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import styled from "styled-components";
import { useCallback, useRef } from "react";
import { MoviesSlider } from "./moviesList";
import { BackBarButtonMini } from "../common/backBarButton";
import smoothScroll from "../../utils/animateScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";
import LazyRow from "../common/LazyRow";

// ============================================================================
// STYLED COMPONENTS (Legacy CSS compatible)
// ============================================================================

var ContentWrapper = styled.div`
  overflow: hidden;
  padding-top: 2rem;
  padding-bottom: 5rem;
`;

var ScrollingRows = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  width: 100%;
  padding-bottom: 5rem;
`;

var HeaderRow = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-right: 40px;
`;

var PageTitle = styled.h2`
  color: white;
  font-size: 2.125rem;
  font-weight: 700;
  margin: 0;
  margin-right: 0.75rem;
  font-family: "AnjomanMax", serif;
`;

var EmptyMessage = styled.div`
  background-color: #212121;
  padding: 1.25rem;
  border-radius: 0.75rem;
  font-size: 1.125rem;
`;

var EmptyText = styled.span`
  color: white;
  font-family: "AnjomanMax", serif;
`;

// ============================================================================
// COMPONENT
// ============================================================================

var CategoriesContent = function (props) {
  var data = props.data || {};

  var focusableResult = useFocusable();
  var ref = focusableResult.ref;
  var focusKey = focusableResult.focusKey;

  var contents = data.contents;
  var children = data.children;

  var hasContentfulItem = useRef({ current: false });

  if (contents && contents.length > 0) {
    contents.forEach(function (item) {
      if (item.data && item.data.length > 0) {
        hasContentfulItem.current = true;
      }
    });
  }

  var inputModeResult = useInputMode();
  var isMouseFocus = inputModeResult.isMouseFocus;
  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      var y = focusProps.y;
      var height = focusProps.height;

      var targetScroll = y > height - 200 ? y - 200 : 0;

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <ContentWrapper>
      <FocusContext.Provider value={focusKey}>
        <ScrollingRows ref={ref}>
          <HeaderRow>
            <BackBarButtonMini />
            <PageTitle>{data?.result?.name}</PageTitle>
          </HeaderRow>
          {/* Only show children categories, not the parent's self-content */}
          {hasContentfulItem.current === true ? (
            contents
              .filter(function (x) {
                return x.key !== data.result.slug;
              })
              ?.map(function (item, index) {
                var childMeta = children?.find(function (x) {
                  return x.key === item.key;
                });
                var title = childMeta?.meta?.bin?.name;
                if (item.data && item.data.length > 0) {
                  return (
                    <LazyRow index={index} key={item.key}>
                      <MoviesSlider
                        movies={item.data}
                        rowTitle={title}
                        onFocus={onRowFocus}
                        shouldFocusSelf={index === 0}
                        id={item.key}
                      />
                    </LazyRow>
                  );
                } else {
                  return null;
                }
              })
          ) : (
            <EmptyMessage>
              <EmptyText>محتوایی یافت نشد</EmptyText>
            </EmptyMessage>
          )}
        </ScrollingRows>
      </FocusContext.Provider>
    </ContentWrapper>
  );
};

export default CategoriesContent;
